// extracted by mini-css-extract-plugin
module.exports = {"ProductInlineBanner":"PIBanner_ProductInlineBanner__cOq_S"};